module.exports = __webpack_public_path__ + "static/fin3-d5d15884b1876ebd3d582923a083f3bb.jpg";